import { render, staticRenderFns } from "./SpecimenWeightTrackingModal.vue?vue&type=template&id=74bf8789"
import script from "./SpecimenWeightTrackingModal.vue?vue&type=script&lang=js"
export * from "./SpecimenWeightTrackingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports